
export default {
  name: 'Press',
  props: {
    page: {
      type: String,
      default: 'home'
    }
  },
  async fetch() {
    const pageNum = this.pageNum = parseInt(this.$route.params.pageNum) || 1
    const res = (await this.$axios.get('https://hirey.com/server/news/list?' + new URLSearchParams({
      type: 'published',
      pageNum,
      pageSize: this.pageSize
    }))).data.result
    this.allNews = this.page === 'home' ? res.allNews.slice(0, 3) : res.allNews
    this.total = res.total

    console.log(this.allNews);
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 15,
      total: 0,
      allNews: [],
      currentPageName: 'newsroom-list-pageNum',
    }
  },
  methods: {
    onClick(index) {
      location.href = `/blog/list/${index}`
    },
    toDateString(publishAt) {
      const strArr = new Date(publishAt).toDateString().split(' ')
      return [strArr[2], strArr[1], strArr[3]].join(' ')
    },
    onMore() {
      location.href = '/blog/list'
    },
    routeNews(news) {
      let routeUrl = this.$router.resolve({
        path: `/blog/${news.id}`,
      });
      window.open(routeUrl.href, '_blank');
    },
    onBack() {
      location.href = '/'
    }
  }
};
